<template>
  <div>
    <el-dialog title="问题反馈" :visible="dialogFeed" width="500px" @close="cancel">
      <div>
        <div class="item">
          <div class="label">问题反馈</div>
          <div class="textarea_box">
            <el-input type="textarea" :rows="4" v-model="desc" placeholder="请输入反馈内容"></el-input>
          </div>
        </div>
        <div class="item">
          <div class="label">添加图片<span class="img_tip">最多可上传4张图片</span></div>
          <div class="imgs_box">
            <!-- <div class="imgs_list"></div>
            <div class="add_box">
              <i style="font-size: 35px;" class="el-icon-plus"></i>
            </div> -->
            <el-upload ref="upload" :class="[hideUpload?'hide':'']" :limit="4" :action="uploadUrl" name="upload_img"
              :multiple="true" :data="uploadData" list-type="picture-card" :on-preview="handlePictureCardPreview"
              :on-change="ChangeImage" :on-success="handleAvatarSuccess" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :modal="false" :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    feedback
  } from "@/api/my";
  export default {
    data() {
      return {
        desc: '',
        dialogImageUrl: '',
        dialogVisible: false,
        uploadData: {
          token: localStorage.getItem('token')
        },
        imgs: [],
        hideUpload: false,
        uploadUrl: ''
      }
    },
    props: {
      dialogFeed: {
        default: false
      }

    },
    computed: {

    },
    watch: {
      dialogFeed(n, o) {
        if (n) {
          this.desc = ''
          this.imgs = []
          this.hideUpload = false
          if (process.env.NODE_ENV == 'production') {
            this.uploadUrl = 'https://www.ttxgm.com/cps_api/user/upload_img'
          } else {
            this.uploadUrl = 'https://www.ttxgm.com/cps_api/user/upload_img'
          }
        } else {
          this.$refs.upload.clearFiles();
        }
      }
    },
    methods: {
      cancel() {
        this.$emit('update:dialogFeed', false)
      },
      handleRemove(file, fileList) {
        // console.log(file, fileList);
        this.hideUpload = fileList.length >= 4
        let url = []
        fileList.forEach(v => {
          url.push(v.response.data.url)
        })
        this.imgs = url
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleAvatarSuccess(res, file) {
        this.imgs.push(res.data.url)
        // console.log(res)
        // console.log(file)
      },
      ChangeImage(file, fileList) {
        this.hideUpload = fileList.length >= 4
      },
      confirm() {
        // console.log(this.imgs)
        if (!this.desc) {
          this.$message({
            message: '请输入反馈内容',
            type: 'warning'
          });
          return
        }
        feedback({
          images: this.imgs.join(','),
          remark: this.desc
        }).then(res => {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.$emit('update:dialogFeed', false)
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .item {
    // display: flex;
    margin-top: 20px;
    font-size: 15px;
    // background-color: #F3F6F5;
    // align-items: center;
    // padding: 0 20px;
    // box-sizing: border-box;

    /deep/ .el-input__inner {
      background-color: #F3F6F5;
    }

    &:first-child {
      margin-top: 0;
    }

    .label {


      .img_tip {
        color: #C1C0C0;
        margin-left: 5px;
        font-size: 14px;
      }
    }

    .textarea_box {
      margin-top: 10px;
    }
  }

  .imgs_box {
    display: flex;
    height: 100px;
    margin-top: 20px;

    .imgs_list {
      display: flex;
    }

    .add_box {
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #C1C0C0;
      margin-left: 20px;
      cursor: pointer;
    }
  }

  // .avatar-uploader {
  .hide /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
    display: none !important;
  }

  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
    // margin-left: 20px;
  }

  /deep/ .el-upload-list__item {
    width: 100px;
    height: 100px;
    border: none;
    margin-right: 20px;
    transition: none !important;

    &:nth-child(4) {
      margin-right: 0;
    }
  }



  // }
</style>



// WEBPACK FOOTER //
// src/component/my/feed_back.vue